"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../theme");
var useStyles = (0, _theme.makeStyles)(function (_ref) {
  var _ref$palette = _ref.palette,
    text = _ref$palette.text,
    primary = _ref$palette.primary,
    shade = _ref.utils.shade;
  return {
    '@global': {
      '.MuiPickersBasePicker-container': {
        '& .MuiPickersToolbar-toolbar': {
          backgroundColor: primary.main,
          color: 'white'
        },
        '& .MuiPickersToolbarText-toolbarBtnSelected': {
          color: 'white'
        },
        '& MuiTypography-subtitle1': {
          color: shade(text.primary, 6)
        },
        '& .MuiPickersDatePickerRoot-dateLandscape': {
          borderRadius: 0,
          borderBottom: "1px solid ".concat(primary.main)
        }
      }
    }
  };
}, {
  name: 'DatePicker'
});
exports.useStyles = useStyles;